// vue路由
import Vue from 'vue';
import Router from 'vue-router';
// 搜了宝 农产品搜缘下载
const downloadslb = () => import('@/page/download/download_slb');
const downloadsy=()=>import('@/page/download/download_sy')
const downloadtc=()=>import('@/page/download/download_tc')
const scanCode = ()=> import('@/page/scanCode');
const share = () => import ('@/page/scanCode/share');
const register = ()=> import ('@/page/register');
const tradeRegister = ()=> import ('@/page/tradeRegister');
const agreement = ()=> import ('@/page/register/agreement');
const sharePoster = () => import ('@/page/register/sharePoster');
const HKregister = () => import ('@/page/register/HK_Register');
const downloadHK = () => import ('@/page/download/download_HK');

Vue.use(Router)

let router = new Router({
  // mode: 'history',
  mode: 'hash',
  routes: [

    {
      path: '/',
      name: 'downloadslb',
      component: downloadslb,
      meta: {
        title: '搜了宝下载',
      }
    },
    {
      path: '/downloadHK',
      name: 'downloadHK',
      component: downloadHK,
      meta: {
        title: '香港手信下载',
      }
    },

    {
      path: '/downloadsy',
      name: 'downloadsy',
      component: downloadsy,
      meta: {
        title: '农产品搜源下载',
      }
    },
    {
      path: '/tradingCenter',
      name: 'tradingCenter',
      component: downloadtc,
      meta: {
        title: '椒易宝下载',
      }
    },

    {
      path: '/scanCode',
      name: 'scanCode',
      component: scanCode,
      meta: {
        title: '核销',
      }
    },
    {
      path: '/share',
      name: 'share',
      component: share,
      meta: {
        title: '520狂欢夜',
      }
    },
    {
      path: '/register',
      name: 'register',
      component: register,
      meta: {
        title: '注册',
      }
    },
    {
      path: '/HKregister',
      name: 'HKregister',
      component: HKregister,
      meta: {
        title: '注册',
      }
    },
    {
      path: '/tradeRegister',
      name: 'tradeRegister',
      component: tradeRegister,
      meta: {
        title: '椒易宝注册',
      }
    },
    {
      path: '/agreement',
      name: 'agreement',
      component: agreement,
      meta: {
        title: '搜了宝APP会员注册服务协议',
      }
    },
    {
      path: '/sharePoster',
      name: 'sharePoster',
      component: sharePoster,
      meta: {
        title: '二维码分享',
      }
    },

  ]
})
router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    window.document.title = to.meta.title
    next();
  }
  next();
})

export default router;



// WEBPACK FOOTER //
// ./src/router/index-download.js